import { useQuery } from '@tanstack/react-query';
import { CASE_LIST_KEY } from '../../utils/constants/queryKeys';
import { getCaseList } from '../services/fn-api/Cases';

export const useGetCaseList = (beneId?: number, groupSubProjectsByParent: boolean = false) => {
  return useQuery({
    queryKey: [CASE_LIST_KEY, beneId, groupSubProjectsByParent],
    queryFn: () => getCaseList(beneId ?? 0, groupSubProjectsByParent),
    enabled: !!beneId,
  });
};
